import React from 'react';

import './VideoCallButton.scss';
import camera_button from '../../images/white_camera.svg';
import { VIDEO_CALL_LINK } from '../../utils/constants';
import { popUpWin } from '../../utils/helpers';

const openPopUp = () => {
  popUpWin(VIDEO_CALL_LINK, 700, 700);
};

const VideoCallButton = ({ text, isSummary }) => (
  <button onClick={openPopUp} >
    <div class="video-call-button__container"
      style={{
        '--margin-container': isSummary && '5px',
        '--width-button': isSummary && '220px'
      }}>
      <div class="video-call-button__elements">
        <img class="video-call-button__camera" src={camera_button} alt="Videocamara" />
        <p class="video-call-button__text">{text}</p>
      </div>
    </div>
  </button>
);

export default VideoCallButton;
